export const DEFAULT_COLOR = '#ffffff'



// WEBPACK FOOTER //
// ./src/components/chrome-picker/constants.ts